import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { MottagningsplatsDetaljerHeaderSvComponent } from "./mottagningsplats-detaljer/mottagningsplats-detaljer-header-sv/mottagningsplats-detaljer-header-sv.component";
import { MottagningsplatsDetaljerHeaderComponent } from "./mottagningsplats-detaljer/mottagningsplats-detaljer-header/mottagningsplats-detaljer-header.component";
import { MottagningsplatsDetaljerPlatsComponent } from "./mottagningsplats-detaljer/mottagningsplats-detaljer-plats/mottagningsplats-detaljer-plats.component";
import { MottagningsplatsDetaljerComponent } from "./mottagningsplats-detaljer/mottagningsplats-detaljer.component";
import { MottagningsplatsService } from "./mottagningsplats.service";
import { SearchMottagningsplatsPanelComponent } from "./search/search-mottagningsplats-panel/search-mottagningsplats-panel.component";
import { SearchMottagningsplatsResultComponent } from "./search/search-mottagningsplats-result/search-mottagningsplats-result.component";
import { SearchMottagningsplatsComponent } from "./search/search-mottagningsplats.component";

@NgModule({
    imports: [
        RaskCommonModule,
        MottagningsplatsDetaljerComponent,
        MottagningsplatsDetaljerHeaderSvComponent,
        MottagningsplatsDetaljerHeaderComponent,
        MottagningsplatsDetaljerPlatsComponent,
        SearchMottagningsplatsComponent,
        SearchMottagningsplatsPanelComponent,
        SearchMottagningsplatsResultComponent
    ],
    exports: [
        SearchMottagningsplatsComponent,
        MottagningsplatsDetaljerComponent
    ],
    providers: [MottagningsplatsService]
})
export class MottagningsplatsModule { }
